<template>
  <el-button
    v-if="hasDownloadLogId"
    type="info"
    size="small"
    class="handle-view"
    :disabled="loading || disabled"
    @click="download"
  >
    {{ loading ? 'Loading...' : label }}
  </el-button>
</template>

<script>
import { request } from '@/utils/utils.js'

export default {
  name: 'TableDownloadButton',
  props: {
    downloadLogId: {
      type: [String, Number],
      default: '',
    },
    apiUrl: {
      type: String,
      required: true,
    },
    paramName: {
      type: String,
      default: 'batch_id',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Download',
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    hasDownloadLogId () {
      return this.downloadLogId !== '' && this.downloadLogId !== null && this.downloadLogId !== undefined
    },
  },
  methods: {
    async download () {
      if (this.loading || this.disabled || !this.hasDownloadLogId) return

      this.loading = true
      const token = localStorage.getItem('Authorization')
      try {
        const response = await request({
          method: 'post',
          url: `${this.apiUrl}?access_token=${token}`,
          params: {
            [this.paramName]: this.downloadLogId,
          },
          headers: {
            'Content-Type': 'application/json',
          },
        })
        if (!response) return

        const { code, data, msg } = response.data
        if (String(code) !== '10000' || !data) {
          throw new Error(msg || 'Temporary download URL is not available')
        }

        window.open(data, '_blank')
      } catch (error) {
        this.showToast(error.message || 'Failed to create temporary download URL.', {
          icon: 'fa-exclamation-circle',
          position: 'top-center',
          duration: 3000,
          fullWidth: false,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.handle-view {
  padding: 9px 15px;
  margin-left: 10px;
}
</style>
